import React, { useContext, useState } from "react";
import { TextField, Button, Container, Typography, Box } from "@mui/material";
import { toast } from "react-toastify";
import AuthContext from "../../contexts/Islogin";

export default function Register({ goBack }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repeat, setRepeat] = useState("");
  const [error, setError] = useState("");
    const { login, setLoginUser,fetchLoginUser ,url } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!name || !email || !password || !repeat) {
      toast.warning("Please fill in all fields.");
      return;
    }
  
    if (password !== repeat) {
      toast.error("Passwords do not match.");
      return;
    }
  
    try {
      const response = await fetch(`${url}api/v1/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          password,
          password_confirmation: repeat,
        }),
      });
  
      const data = await response.json();
  
      if (response.ok) {
        toast.success("Registration successful!");
        goBack();
      } else if (response.status === 422 && data.error) {
        // نمایش همه پیام‌های موجود در data.error
        Object.entries(data.error).forEach(([field, messages]) => {
          messages.forEach((msg) => toast.error(msg));
        });
      } else {
        toast.error(data.message || "Registration failed.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong.");
    }
  };
  
  
  
  

  return (
    <Container maxWidth="sm">
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: 8 }}>
        <Typography variant="h4" gutterBottom>Register</Typography>
        <form onSubmit={handleSubmit} style={{ width: "100%", marginTop: 1 }}>
          <TextField
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Repeat Password"
            type="password"
            value={repeat}
            onChange={(e) => setRepeat(e.target.value)}
            fullWidth
            margin="normal"
          />
          {error && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}
          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
            Register
          </Button>
          <Button
            onClick={goBack}
            color="secondary"
            fullWidth
            style={{ marginTop: "10px" }}
          >
            Already have an account? Login
          </Button>
        </form>
      </Box>
    </Container>
  );
}
